import React, { Component } from 'react';

import logo from '../../img/logo.svg';
import '../Quiz/Quiz.css';


class AccountDetails extends Component {

    render(){
        return (
            <div className="quiz">
                <div className="quiz__left-side">
                    <div className="quiz__area">
                        <div className="form">
                            <h1 className="form__title">Account Details</h1>
                        </div>
                    </div>
                </div>
                <div className="quiz__right-side">
                    <img src={logo} alt="" className="quiz__right-side-logo"/>

                    <div className="phone-container">
                        <div className="phone">
                            <div className="screen">
                                <div className="screen__number-container">
                                    <p className="screen__number">0</p>
                                    <p className="screen__number-text">complete</p>
                                </div>
                            </div>
                        </div>
                        <div className="phone-container__marker phone-container__marker_vitta">Vata</div>
                        <div className="phone-container__marker phone-container__marker_pitta">Pitta</div>
                        <div className="phone-container__marker phone-container__marker_kapha">Kapha</div>
                    </div>

                </div>
            </div>
        )
    }

}

export default AccountDetails;


// WEBPACK FOOTER //
// ./src/components/Account/AccountDetails.js